/* eslint-disable react/no-array-index-key */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { MdClose, MdWheelchairPickup } from 'react-icons/md';
import SelectedFlightDetails from '../one-way/SelectedFlightDetails';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import {
  getObjectFromLS,
  getUserAgentId,
} from '../../shared/helper-utils/localStorage';
import {
  getFlightTicketApi,
  getSeatLayoutApi,
  getSSRApi,
  rescheduleBookFlightApi,
} from '../../api/flightApi';
import {
  formatCurrency,
  formatDate,
  getNewDate,
  isEmpty,
} from '../../shared/helper-utils/appUtils';
import { APP_USER_PROFILE } from '../../saas/AppStorageStaticNames';
import { DATE_MONTH_DAY_FORMAT } from '../../shared/constants/Constants';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppButton from '../../shared/components/app-button/AppButton';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import { seatGroupingHook, ssrGroupingHook } from '../add-ssr/ssrGroupingHooks';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import SeatSelectionComponent from './SeatSelectionComponent';
import MealSelectionComponent from './MealSelectionComponent';
import BaggageSelectionComponent from './BaggageSelectionComponent';
import SpecialSsrSelectionComponent from './SpecialSsrSelectionComponent';
import AppModal from '../../shared/components/app-modal/AppModal';

const JOURNEY_TYPES = {
  ONWARD: 'onward',
  RETURN: 'return',
  ROUND_TRIP: 'roundtrip',
  ONE_WAY: 'oneway',
};

const ADDONS = {
  MEALS: 'meals',
  BAGGAGE: 'baggage',
  SPECIAL_SSR: 'special_ssr',
};

function ResheduleBookingPage() {
  const navigate = useNavigate();
  const userProfile = getObjectFromLS(APP_USER_PROFILE);
  const { state } = useLocation();
  const { changeBookingSector } = state;
  const [searchRequest] = useState(changeBookingSector[0]);
  const { transactionId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const flightInvoiceRef = useRef(undefined);
  const headerDetailsRef = useRef(undefined);
  const fareSummaryRef = useRef(undefined);
  const [selectedOnwardFlight, setSelectedOnwardFlight] = useState(undefined);
  const [selectedReturnFlight, setSelectedReturnFlight] = useState(undefined);
  const [remarks, setRemarks] = useState('');
  const [alert, setAlert] = useState(false);
  const sectorsWithFlightRef = useRef({});
  const [userSelectedSsrRows, setUserSelectedSsrRows] = useState({});
  const flightLegsWithSeatsRef = useRef({});
  const flightLegsWithMealRef = useRef({});
  const flightLegsWithBaggageRef = useRef({});
  const flightLegsWithSpecialSsrRef = useRef({});
  const [activeSeatIndex, setActiveSeatIndex] = useState(0);
  const [activeBagIndex, setActiveBagIndex] = useState(0);
  const [activeMealIndex, setActiveMealIndex] = useState(0);
  const [activeSsrIndex, setActiveSsrIndex] = useState(0);
  const [seatSelectionSector, setSeatSelectionSector] = useState('');
  const [mealSelectionSector, setMealSelectionSector] = useState('');
  const [baggageSelectionSector, setBaggageSelectionSector] = useState('');
  const [specialSsrSelectionSector, setSpecialSsrSelectionSector] =
    useState('');
  const [showMeals, setShowMeals] = useState(false);
  const [showBaggage, setShowBaggage] = useState(false);
  const [showSpecialSsr, setShowSpecialSsr] = useState(false);
  const [showSeatMap, setShowSeatMap] = useState(false);
  const [showPrice, setShowPrice] = useState(false);
  const totalFareRef = useRef(0);
  const [priceSummary, setPriceSummary] = useState([]);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  const getSsrRows = (sector, list, ssrType, jType) => {
    const sec = sector.split('-');
    const ssrList = [];
    list.forEach((traveller) => {
      const fullName = traveller.fullname;
      const names = fullName.split(' ');
      ssrList.push({
        flightNumber: sectorsWithFlightRef.current[sector]
          ? sectorsWithFlightRef.current[sector].flightnumber
          : '',
        carrier: sectorsWithFlightRef.current[sector]
          ? sectorsWithFlightRef.current[sector].carrier
          : '',
        destination: sec[1].trim(),
        jtype: jType.toLowerCase(),
        origin: sec[0].trim(),
        passenger_fname: names[1],
        passenger_lname: names[2],
        passenger_title: names[0],
        paxid: traveller.paxid,
        paxtype: traveller.paxtype,
        ssr_chargeableamount: '',
        ssrcode: '',
        ssrname: '',
        ssrid: '',
        ssrtype: ssrType,
        tripnumber: traveller.SegmentNumber,
        fullName: traveller.fullname,
      });
    });
    return ssrList;
  };

  const getUserSsr = () => {
    const userSelectedSsrRowsTemp = {};
    let onwardCount = 0;
    let paxList = [];
    const isBothSectorsChecked = state.changeBookingSector.every(
      (s) => s.checked,
    );
    Object.keys(sectorsWithFlightRef.current).forEach((sector) => {
      if (sectorsWithFlightRef.current[sector].journeyType === 'onward') {
        onwardCount += 1;
      }
      let cbslist = [];
      let isOneway = false;

      if (isBothSectorsChecked) {
        cbslist = state.changeBookingSector.filter(
          (x) =>
            x.checked &&
            sectorsWithFlightRef.current[sector].journeyType.toLowerCase() ===
              x.flightType.toLowerCase(),
        );
        isOneway = false;
      } else {
        cbslist = state.changeBookingSector.filter((x) => x.checked);
        isOneway = true;
      }
      cbslist.forEach((cbs) => {
        if (cbs.flightType === 'Onward') {
          paxList = cbs.passengers.filter(
            (x) => x.isSelected && x.status === 'confirmed',
          );
          userSelectedSsrRowsTemp[sector] = {
            baggageRows: getSsrRows(sector, paxList, 'baggage', 'onward'),
            mealRows: getSsrRows(sector, paxList, 'meal', 'onward'),
            seatRows: getSsrRows(sector, paxList, 'seat', 'onward'),
            specialSsrRows: getSsrRows(sector, paxList, 'specialssr', 'onward'),
          };
        }
        if (cbs.flightType !== 'Onward') {
          const list = cbs.passengers.filter(
            (x) => x.isSelected && x.status === 'confirmed',
          );
          userSelectedSsrRowsTemp[sector] = {
            baggageRows: getSsrRows(
              sector,
              list,
              'baggage',
              isOneway ? 'onward' : 'return',
            ),
            mealRows: getSsrRows(
              sector,
              list,
              'meal',
              isOneway ? 'onward' : 'return',
            ),
            specialSsrRows: getSsrRows(
              sector,
              list,
              'specialssr',
              isOneway ? 'onward' : 'return',
            ),
            seatRows: getSsrRows(
              sector,
              list,
              'seat',
              isOneway ? 'onward' : 'return',
            ),
          };
        }
      });
    });
    if (onwardCount > 1) {
      const keys = Object.keys(sectorsWithFlightRef.current);
      const origin = keys[0].split('-')[0].trim();
      const destination = keys[keys.length - 1].split('-')[1].trim();
      const sectorKey = `${origin} - ${destination}`;
      if (userSelectedSsrRowsTemp[sectorKey] === undefined) {
        userSelectedSsrRowsTemp[sectorKey] = {
          baggageRows: getSsrRows(sectorKey, paxList, 'baggage', 'onward'),
          mealRows: getSsrRows(sectorKey, paxList, 'meal', 'onward'),
          seatRows: getSsrRows(sectorKey, paxList, 'seat', 'onward'),
          specialSsrRows: getSsrRows(
            sectorKey,
            paxList,
            'specialssr',
            'onward',
          ),
        };
      }
    }
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
  };

  const getData = async () => {
    setIsLoading(true);
    const agentId = getUserAgentId();
    const response = await getFlightTicketApi(transactionId, agentId);
    if (response) {
      const { FlightInvoice } = response.ApiStatus.Result.FullFlightDetails;
      flightInvoiceRef.current = FlightInvoice;
      let { SectorRecord } = FlightInvoice.SectorRecords;
      SectorRecord = Array.isArray(SectorRecord)
        ? SectorRecord
        : [SectorRecord];
      const Origin = SectorRecord[0].OriginFullName;
      const Destination =
        SectorRecord[SectorRecord.length - 1].DestinationFullName;
      headerDetailsRef.current = {
        PassengerTitle: FlightInvoice.FlightRecord.PassengerTitle,
        PassengerFirstName: FlightInvoice.FlightRecord.PassengerFirstName,
        PassengerLastName: FlightInvoice.FlightRecord.PassengerLastName,
        PassengerContact: FlightInvoice.FlightRecord.PassengerContact,
        PassengerEmail: FlightInvoice.FlightRecord.PassengerEmail,
        JType: FlightInvoice.FlightRecord.JType,
        Origin,
        Destination,
        NumPax: FlightInvoice.FlightRecord.NumPax,
      };
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const getSeatLayout = async () => {
    const { repriseResponse, journeyType } = state;
    if (journeyType === JOURNEY_TYPES.ROUND_TRIP) {
      const onwardSeatResponse = await getSeatLayoutApi(
        userProfile.agentId,
        JOURNEY_TYPES.ONWARD,
        repriseResponse.bookingkey,
      );
      const returnSeatResponse = await getSeatLayoutApi(
        userProfile.agentId,
        JOURNEY_TYPES.RETURN,
        repriseResponse.bookingkey,
      );
      if (
        onwardSeatResponse &&
        onwardSeatResponse.Root &&
        onwardSeatResponse.Root.Result &&
        onwardSeatResponse.Root.Result !== null &&
        onwardSeatResponse.Root.Result.list
      ) {
        const { SeatMap } = onwardSeatResponse.Root.Result.list;
        flightLegsWithSeatsRef.current = seatGroupingHook(
          SeatMap,
          flightLegsWithSeatsRef.current,
        );
        const sectors = Object.keys(flightLegsWithSeatsRef.current);
        setSeatSelectionSector(sectors[0]);
      }
      if (
        returnSeatResponse &&
        returnSeatResponse.Root &&
        returnSeatResponse.Root.Result &&
        returnSeatResponse.Root.Result !== null &&
        returnSeatResponse.Root.Result.list
      ) {
        const { SeatMap } = returnSeatResponse.Root.Result.list;
        flightLegsWithSeatsRef.current = seatGroupingHook(
          SeatMap,
          flightLegsWithSeatsRef.current,
        );
        const sectors = Object.keys(flightLegsWithSeatsRef.current);
        setSeatSelectionSector(sectors[0]);
      }
    } else {
      const seatResponse = await getSeatLayoutApi(
        userProfile.agentId,
        JOURNEY_TYPES.ONWARD,
        repriseResponse.bookingkey,
      );
      if (
        seatResponse &&
        seatResponse.Root &&
        seatResponse.Root.Result !== null &&
        seatResponse.Root.Result.list
      ) {
        const { SeatMap } = seatResponse.Root.Result.list;
        flightLegsWithSeatsRef.current = seatGroupingHook(
          SeatMap,
          flightLegsWithSeatsRef.current,
        );
        const sectors = Object.keys(flightLegsWithSeatsRef.current);
        setSeatSelectionSector(sectors[0]);
      }
    }
  };

  const getSSRLayout = async () => {
    const { repriseResponse, journeyType } = state;
    if (journeyType === JOURNEY_TYPES.ROUND_TRIP) {
      const onwardResponse = await getSSRApi(
        repriseResponse.bookingkey,
        JOURNEY_TYPES.ONWARD,
      );
      if (
        onwardResponse &&
        onwardResponse.list &&
        onwardResponse.list !== null &&
        !isEmpty(onwardResponse.list)
      ) {
        const { flightLegMeal, flightLegBaggage, flightLegSpecialSsr } =
          ssrGroupingHook(
            onwardResponse,
            flightLegsWithMealRef.current,
            flightLegsWithBaggageRef.current,
            flightLegsWithSpecialSsrRef.current,
          );
        flightLegsWithMealRef.current = flightLegMeal;
        flightLegsWithBaggageRef.current = flightLegBaggage;
        flightLegsWithSpecialSsrRef.current = flightLegSpecialSsr;
        if (Object.keys(flightLegsWithMealRef.current).length > 0) {
          setMealSelectionSector(Object.keys(flightLegsWithMealRef.current)[0]);
        }
        if (Object.keys(flightLegsWithBaggageRef.current).length > 0) {
          setBaggageSelectionSector(
            Object.keys(flightLegsWithBaggageRef.current)[0],
          );
        }
        if (Object.keys(flightLegsWithSpecialSsrRef.current).length > 0) {
          setSpecialSsrSelectionSector(
            Object.keys(flightLegsWithSpecialSsrRef.current)[0],
          );
        }
      }
      const returnResponse = await getSSRApi(
        repriseResponse.bookingkey,
        JOURNEY_TYPES.RETURN,
      );
      if (
        returnResponse &&
        returnResponse.list &&
        returnResponse.list !== null &&
        !isEmpty(returnResponse.list)
      ) {
        const { flightLegMeal, flightLegBaggage, flightLegSpecialSsr } =
          ssrGroupingHook(
            returnResponse,
            flightLegsWithMealRef.current,
            flightLegsWithBaggageRef.current,
            flightLegsWithSpecialSsrRef.current,
          );
        flightLegsWithMealRef.current = flightLegMeal;
        flightLegsWithBaggageRef.current = flightLegBaggage;
        flightLegsWithSpecialSsrRef.current = flightLegSpecialSsr;
        if (Object.keys(flightLegsWithMealRef.current).length > 0) {
          setMealSelectionSector(Object.keys(flightLegsWithMealRef.current)[0]);
        }
        if (Object.keys(flightLegsWithBaggageRef.current).length > 0) {
          setBaggageSelectionSector(
            Object.keys(flightLegsWithBaggageRef.current)[0],
          );
        }
        if (Object.keys(flightLegsWithSpecialSsrRef.current).length > 0) {
          setSpecialSsrSelectionSector(
            Object.keys(flightLegsWithSpecialSsrRef.current)[0],
          );
        }
      }
    } else {
      const response = await getSSRApi(
        repriseResponse.bookingkey,
        JOURNEY_TYPES.ONWARD,
      );
      if (
        response &&
        response.list &&
        response.list !== null &&
        !isEmpty(response.list)
      ) {
        const { flightLegMeal, flightLegBaggage, flightLegSpecialSsr } =
          ssrGroupingHook(
            response,
            flightLegsWithMealRef.current,
            flightLegsWithBaggageRef.current,
            flightLegsWithSpecialSsrRef.current,
          );
        flightLegsWithMealRef.current = flightLegMeal;
        flightLegsWithBaggageRef.current = flightLegBaggage;
        flightLegsWithSpecialSsrRef.current = flightLegSpecialSsr;
        if (Object.keys(flightLegsWithMealRef.current).length > 0) {
          setMealSelectionSector(Object.keys(flightLegsWithMealRef.current)[0]);
        }
        if (Object.keys(flightLegsWithBaggageRef.current).length > 0) {
          setBaggageSelectionSector(
            Object.keys(flightLegsWithBaggageRef.current)[0],
          );
        }
        if (Object.keys(flightLegsWithSpecialSsrRef.current).length > 0) {
          setSpecialSsrSelectionSector(
            Object.keys(flightLegsWithSpecialSsrRef.current)[0],
          );
        }
      }
    }
  };

  const getInitData = async () => {
    setIsLoading(true);
    const response = await getFlightTicketApi(transactionId, getUserAgentId());
    if (response && !isEmpty(response)) {
      const { FlightInvoice } = response.ApiStatus.Result.FullFlightDetails;
      flightInvoiceRef.current = FlightInvoice;
      let { SectorRecord } = FlightInvoice.SectorRecords;
      SectorRecord = Array.isArray(SectorRecord)
        ? SectorRecord
        : [SectorRecord];
      const Origin = SectorRecord[0].OriginFullName;
      const Destination =
        SectorRecord[SectorRecord.length - 1].DestinationFullName;
      headerDetailsRef.current = {
        PassengerTitle: FlightInvoice.FlightRecord.PassengerTitle,
        PassengerFirstName: FlightInvoice.FlightRecord.PassengerFirstName,
        PassengerLastName: FlightInvoice.FlightRecord.PassengerLastName,
        PassengerContact: FlightInvoice.FlightRecord.PassengerContact,
        PassengerEmail: FlightInvoice.FlightRecord.PassengerEmail,
        JType: FlightInvoice.FlightRecord.JType,
        Origin,
        Destination,
        NumPax: FlightInvoice.FlightRecord.NumPax,
      };
      const { repriseResponse, journeyType } = state;
      const { flightjourneys } = repriseResponse;
      const onwardFlight =
        flightjourneys[0].flightoptions[0].recommendedflight[0];
      let returnFlight;
      setSelectedOnwardFlight(onwardFlight);
      if (journeyType.toLowerCase() === 'roundtrip') {
        if (repriseResponse.domint === 'domestic') {
          returnFlight =
            flightjourneys[1].flightoptions[0].recommendedflight[0];
        } else {
          returnFlight =
            flightjourneys[0].flightoptions[0].recommendedflight[1];
        }
      }
      setSelectedReturnFlight(returnFlight);
      let fares = repriseResponse.reschedulefarestr;
      fares = fares.split(':');
      fareSummaryRef.current = {
        newFare: repriseResponse.newamount,
        reschedulePanalties: repriseResponse.apireschcharges,
        amountTobePaid:
          parseFloat(repriseResponse.newamount) -
          parseFloat(repriseResponse.oldamount) +
          parseFloat(repriseResponse.apireschcharges),
        oldFare: repriseResponse.oldamount,
        rsCharge: parseInt(fares[2], 10),
        fareDiff: parseInt(fares[3], 10),
        debitamount: parseInt(fares[4], 10),
        agencycharges: parseInt(fares[5], 10),
        agentAmountDue: parseInt(fares[6], 10),
      };

      if (state.journeyType === 'oneway') {
        const flights =
          state.repriseResponse.flightjourneys[0].flightoptions[0]
            .recommendedflight[0];
        const { flightlegs } = flights;
        flightlegs.forEach((fl) => {
          fl.TripNumber = 1;
          fl.Faretype = flights.flightfare.faretype;
          fl.journeyType = 'onward';
          sectorsWithFlightRef.current[`${fl.origin} - ${fl.destination}`] = {
            carrier: fl.carrier,
            flightnumber: fl.flightnumber,
            journeyType: 'onward',
          };
        });
        const fullSectorKey = `${flightlegs[0].origin} - ${
          flightlegs[flightlegs.length - 1].destination
        }`;
        if (
          Object.keys(sectorsWithFlightRef.current).indexOf(fullSectorKey) ===
          -1
        ) {
          sectorsWithFlightRef.current[fullSectorKey] = {
            carrier: flightlegs[0].carrier,
            flightnumber: flightlegs[0].flightnumber,
            journeyType: 'onward',
          };
        }
      } else {
        const flights =
          state.repriseResponse.flightjourneys[0].flightoptions[0]
            .recommendedflight[0];
        const { flightlegs } = flights;
        flightlegs.forEach((fl) => {
          fl.TripNumber = 1;
          fl.journeyType = 'onward';
          fl.Faretype = flights.flightfare.faretype;
          sectorsWithFlightRef.current[`${fl.origin} - ${fl.destination}`] = {
            carrier: fl.carrier,
            flightnumber: fl.flightnumber,
            journeyType: 'onward',
          };
        });
        const fullSectorKey = `${flightlegs[0].origin} - ${
          flightlegs[flightlegs.length - 1].destination
        }`;
        if (
          Object.keys(sectorsWithFlightRef.current).indexOf(fullSectorKey) ===
          -1
        ) {
          sectorsWithFlightRef.current[fullSectorKey] = {
            carrier: flightlegs[0].carrier,
            flightnumber: flightlegs[0].flightnumber,
            journeyType: 'onward',
          };
        }
        const returnFlights =
          state.repriseResponse.flightjourneys[1].flightoptions[0]
            .recommendedflight[0];
        const returnFlightLegs = returnFlights.flightlegs;
        returnFlightLegs.forEach((fl) => {
          fl.TripNumber = 2;
          fl.journeyType = 'return';
          fl.Faretype = returnFlights.flightfare.faretype;
          sectorsWithFlightRef.current[`${fl.origin} - ${fl.destination}`] = {
            carrier: fl.carrier,
            flightnumber: fl.flightnumber,
            journeyType: 'return',
          };
        });
        const fullSectorKeyReturn = `${returnFlightLegs[0].origin} - ${
          returnFlightLegs[returnFlightLegs.length - 1].destination
        }`;
        if (
          Object.keys(sectorsWithFlightRef.current).indexOf(
            fullSectorKeyReturn,
          ) === -1
        ) {
          sectorsWithFlightRef.current[fullSectorKeyReturn] = {
            carrier: returnFlightLegs[0].carrier,
            flightnumber: returnFlightLegs[0].flightnumber,
            journeyType: 'return',
          };
        }
      }
      await getData();
      getUserSsr();
      await getSSRLayout();
      await getSeatLayout();
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getInitData();
  }, []);

  const handleMakePayment = async () => {
    setIsLoading(true);
    try {
      const paxList = [];
      state.changeBookingSector.forEach((sec) => {
        if (
          sec.checked &&
          sec.selectedDate !== undefined &&
          sec.selectedDate !== ''
        ) {
          sec.passengers.forEach((cur) => {
            if (cur.isSelected && cur.status === 'confirmed') {
              paxList.push({
                paxid: cur.paxid,
                tripnumber: cur.tripnumber,
              });
            }
          });
        }
      });
      const ssrList = [];
      Object.keys(userSelectedSsrRows).forEach((sector) => {
        userSelectedSsrRows[sector].baggageRows.forEach((row) => {
          if (row.ssr_chargeableamount !== '' && row.hasSsr !== true) {
            delete row.fullName;
            delete row.hasSsr;
            ssrList.push(row);
          }
        });
        userSelectedSsrRows[sector].mealRows.forEach((row) => {
          if (row.ssr_chargeableamount !== '') {
            delete row.fullName;
            delete row.hasSsr;
            ssrList.push(row);
          }
        });
        userSelectedSsrRows[sector].seatRows.forEach((row) => {
          if (row.ssr_chargeableamount !== '' && row.hasSsr !== true) {
            delete row.fullName;
            delete row.hasSsr;
            ssrList.push(row);
          }
        });
        userSelectedSsrRows[sector].specialSsrRows.forEach((row) => {
          if (row.ssr_chargeableamount !== '' && row.hasSsr !== true) {
            delete row.fullName;
            delete row.hasSsr;
            ssrList.push(row);
          }
        });
      });
      const request = {
        reschedulerequest: {
          taxInfoStr: state.repriseResponse.bookingkey,
          mastertxid: transactionId,
          paymentmode: 'cashcard',
          paxdetails: paxList,
          contact_name: `${headerDetailsRef.current.PassengerTitle} ${headerDetailsRef.current.PassengerFirstName} ${headerDetailsRef.current.PassengerLastName}`,
          contact_number: headerDetailsRef.current.PassengerContact,
          remarks,
          agentid: getUserAgentId(),
          ssrList: {
            SSRRow: ssrList,
          },
        },
      };
      const response = await rescheduleBookFlightApi(
        request,
        getUserAgentId(),
        headerDetailsRef.current.JType.toLowerCase(),
      );
      if (response && response.Root && response.Root.Status === 'OK') {
        setAlert({
          variant: 'success',
          title: 'Change Booking Success',
          description:
            'You have successfully booked a ticket, Redirecting to ticket page...',
        });
        setTimeout(() => {
          navigate(`/flight/ticket/${response?.Root?.Result}`);
        }, 2000);
      } else {
        setAlert({
          variant: 'error',
          title: 'Change Booking',
          description: response?.Root?.Result || 'Failed to Reschedule',
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setAlert({
        variant: 'error',
        title: 'Change Booking',
        description: 'Failed to the Reschedule',
      });
    }
  };

  const handleAddAddOn = (addOnType) => {
    if (addOnType === ADDONS.MEALS) {
      setShowMeals(true);
    } else if (addOnType === ADDONS.BAGGAGE) {
      setShowBaggage(true);
    } else if (addOnType === ADDONS.SPECIAL_SSR) {
      setShowSpecialSsr(true);
    } else if (addOnType === ADDONS.SEATS) {
      setShowSeatMap(true);
    }
  };

  const updatePrice = (selectedSsrRows) => {
    let baggageCount = 0;
    let baggageSum = 0;
    let mealSum = 0;
    let mealCount = 0;
    let seatsSum = 0;
    let seatsCount = 0;
    let specialSsrCount = 0;
    let specialSsrSum = 0;
    let isShowPrice = false;
    Object.keys(selectedSsrRows).forEach((sector) => {
      const { baggageRows } = selectedSsrRows[sector];
      const { mealRows } = selectedSsrRows[sector];
      const { seatRows } = selectedSsrRows[sector];
      const { specialSsrRows } = selectedSsrRows[sector];
      baggageSum += baggageRows.reduce((acc, cur) => {
        if (cur.ssr_chargeableamount !== '' && cur.hasSsr !== true) {
          acc += cur.ssr_chargeableamount;
          baggageCount += 1;
          isShowPrice = true;
        }
        return acc;
      }, 0);
      mealSum += mealRows.reduce((acc, cur) => {
        if (cur.ssr_chargeableamount !== '' && cur.hasSsr !== true) {
          acc += cur.ssr_chargeableamount;
          mealCount += 1;
          isShowPrice = true;
        }
        return acc;
      }, 0);
      seatsSum += seatRows.reduce((acc, cur) => {
        if (cur.ssr_chargeableamount !== '' && cur.hasSsr !== true) {
          acc += cur.ssr_chargeableamount;
          seatsCount += 1;
          isShowPrice = true;
        }
        return acc;
      }, 0);
      specialSsrSum += specialSsrRows.reduce((acc, cur) => {
        if (cur.ssr_chargeableamount !== '' && cur.hasSsr !== true) {
          acc += cur.ssr_chargeableamount;
          specialSsrCount += 1;
          isShowPrice = true;
        }
        return acc;
      }, 0);
    });
    totalFareRef.current = baggageSum + mealSum + seatsSum + specialSsrSum;
    const summary = [];
    summary.push({
      show: baggageCount > 0,
      label: `${baggageCount} x Baggage`,
      value: baggageSum,
    });
    summary.push({
      show: mealCount > 0,
      label: `${mealCount} x Meal`,
      value: mealSum,
    });
    summary.push({
      show: seatsCount > 0,
      label: `${seatsCount} x Seat`,
      value: seatsSum,
    });
    summary.push({
      show: specialSsrCount > 0,
      label: `${specialSsrCount} x Special SSr`,
      value: specialSsrSum,
    });
    setShowPrice(isShowPrice);
    setPriceSummary(summary);
  };

  const getByName = (userBaggageRows) => {
    return userBaggageRows.reduce((acc, cur) => {
      if (acc[cur.fullName]) {
        acc[cur.fullName].push(cur);
      } else {
        acc[cur.fullName] = [cur];
      }
      return acc;
    }, {});
  };

  const handleAddBaggage = (baggage) => {
    const { origin, destination } = baggage;
    const sector = `${origin} - ${destination}`;
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    if (
      userSelectedSsrRowsTemp[sector] &&
      userSelectedSsrRowsTemp[sector].baggageRows
    ) {
      const userBaggageRows = userSelectedSsrRowsTemp[sector].baggageRows;
      const byName = getByName(userBaggageRows);
      const keys = Object.keys(byName);
      const fullName = keys[activeBagIndex];
      const firstRow = byName[fullName][0];
      if (firstRow && firstRow.hasSsr) {
        return;
      }
      let obj;
      if (firstRow && isEmpty(firstRow.ssrcode)) {
        obj = {
          ...firstRow,
          fullName,
          ssrcode: baggage.ssrcode,
          ssrid: baggage.ssrid,
          ssrname: baggage.ssrname,
          ssr_chargeableamount: baggage.chargeableamount,
          origin:
            sector && sector.split('-')[0]
              ? sector.split('-')[0].trim()
              : firstRow.origin,
          destination:
            sector && sector.split('-')[1]
              ? sector.split('-')[1].trim()
              : firstRow.destination,
          ssrtype: 'baggage',
          hasSsr: false,
        };
      } else {
        obj = {
          ...firstRow,
          fullName,
          ssrcode: baggage.ssrcode,
          ssrid: baggage.ssrid,
          ssrname: baggage.ssrname,
          ssr_chargeableamount: baggage.chargeableamount,
        };
      }
      userSelectedSsrRowsTemp[sector].baggageRows[activeBagIndex] = { ...obj };
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      updatePrice(userSelectedSsrRowsTemp);
    }
  };
  const handleRemoveBaggage = (baggage, index) => {
    const { origin, destination } = baggage;
    const sector = `${origin} - ${destination}`;
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    if (
      userSelectedSsrRowsTemp[sector] &&
      userSelectedSsrRowsTemp[sector].baggageRows
    ) {
      const userBaggageRows = userSelectedSsrRowsTemp[sector].baggageRows;
      const byName = getByName(userBaggageRows);
      const keys = Object.keys(byName);
      const fullName = keys[index];
      const firstRow = byName[fullName][0];
      if (firstRow && firstRow.hasSsr) {
        return;
      }
      const baggageIndex = userBaggageRows.findIndex(
        (b) =>
          b.hasSsr !== true &&
          b.fullName === fullName &&
          b.ssrcode === baggage.ssrcode,
      );
      userBaggageRows[baggageIndex] = {
        ...userBaggageRows[baggageIndex],
        ssrcode: '',
        ssrid: '',
        ssrname: '',
        ssr_chargeableamount: '',
      };
      userSelectedSsrRowsTemp[sector].baggageRows = userBaggageRows;
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      updatePrice(userSelectedSsrRowsTemp);
    }
  };

  const getSelectedBaggage = (userBaggageRows, index, sector) => {
    const filtered = userBaggageRows.filter(
      (row) => row.ssrname !== '' && row.ssr_chargeableamount !== '',
    );
    return filtered.length === 0 ? (
      'Select Baggage'
    ) : (
      <ul className="selected-meals">
        {filtered.map((baggage, bmi) => (
          <li key={bmi}>
            <span>
              {baggage.ssrname} • {formatCurrency(baggage.ssr_chargeableamount)}
            </span>
            {baggage.hasSsr !== true && (
              <AppIconButton
                onClick={() => handleRemoveBaggage(baggage, index, sector)}
                variant="secondary"
              >
                <MdClose />
              </AppIconButton>
            )}
          </li>
        ))}
      </ul>
    );
  };

  const handleAddMeal = (ssr) => {
    const { origin, destination } = ssr;
    const sector = `${origin} - ${destination}`;
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    if (
      userSelectedSsrRowsTemp[sector] &&
      userSelectedSsrRowsTemp[sector].mealRows
    ) {
      const userSsrRows = userSelectedSsrRowsTemp[sector].mealRows;
      const byName = getByName(userSsrRows);
      const keys = Object.keys(byName);
      const fullName = keys[activeMealIndex];
      const firstRow = byName[fullName][0];
      if (firstRow && firstRow.hasSsr) {
        return;
      }
      let obj;
      if (firstRow && isEmpty(firstRow.ssrcode)) {
        obj = {
          ...firstRow,
          fullName,
          ssrcode: ssr.ssrcode,
          ssrid: ssr.ssrid,
          ssrname: ssr.ssrname,
          ssr_chargeableamount: ssr.chargeableamount,
          origin:
            sector && sector.split('-')[0]
              ? sector.split('-')[0].trim()
              : firstRow.origin,
          destination:
            sector && sector.split('-')[1]
              ? sector.split('-')[1].trim()
              : firstRow.destination,
          ssrtype: 'meal',
          hasSsr: false,
        };
      } else {
        obj = {
          ...firstRow,
          fullName,
          ssrcode: ssr.ssrcode,
          ssrid: ssr.ssrid,
          ssrname: ssr.ssrname,
          ssr_chargeableamount: ssr.chargeableamount,
        };
      }
      userSelectedSsrRowsTemp[sector].mealRows[activeMealIndex] = { ...obj };
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      updatePrice(userSelectedSsrRowsTemp);
    }
  };

  const handleRemoveMeal = (ssr, index) => {
    const { origin, destination } = ssr;
    const sector = `${origin} - ${destination}`;
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    if (
      userSelectedSsrRowsTemp[sector] &&
      userSelectedSsrRowsTemp[sector].mealRows
    ) {
      const userSsrRows = userSelectedSsrRowsTemp[sector].mealRows;
      const byName = getByName(userSsrRows);
      const keys = Object.keys(byName);
      const fullName = keys[index];
      const firstRow = byName[fullName][0];
      if (firstRow && firstRow.hasSsr) {
        return;
      }
      const baggageIndex = userSsrRows.findIndex(
        (b) =>
          b.hasSsr !== true &&
          b.fullName === fullName &&
          b.ssrcode === ssr.ssrcode,
      );
      userSsrRows[baggageIndex] = {
        ...userSsrRows[baggageIndex],
        ssrcode: '',
        ssrid: '',
        ssrname: '',
        ssr_chargeableamount: '',
      };
      userSelectedSsrRowsTemp[sector].mealRows = userSsrRows;
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      updatePrice(userSelectedSsrRowsTemp);
    }
  };

  const getSelectedMeals = (userSsrRows, index, sector) => {
    const filtered = userSsrRows.filter(
      (row) => row.ssrname !== '' && row.ssr_chargeableamount !== '',
    );
    return filtered.length === 0 ? (
      'Select Meal'
    ) : (
      <ul className="selected-meals">
        {filtered.map((ssr, bmi) => (
          <li key={bmi}>
            <span>
              {ssr.ssrname} • {formatCurrency(ssr.ssr_chargeableamount)}
            </span>
            {ssr.hasSsr !== true && (
              <AppIconButton
                onClick={() => handleRemoveMeal(ssr, index, sector)}
                variant="secondary"
              >
                <MdClose />
              </AppIconButton>
            )}
          </li>
        ))}
      </ul>
    );
  };

  const handleAddSpecialSsr = (ssr) => {
    const { origin, destination } = ssr;
    const sector = `${origin} - ${destination}`;
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    if (
      userSelectedSsrRowsTemp[sector] &&
      userSelectedSsrRowsTemp[sector].specialSsrRows
    ) {
      const userSsrRows = userSelectedSsrRowsTemp[sector].specialSsrRows;
      const byName = getByName(userSsrRows);
      const keys = Object.keys(byName);
      const fullName = keys[activeSsrIndex];
      const firstRow = byName[fullName][0];
      if (firstRow && firstRow.hasSsr) {
        return;
      }
      let obj;
      if (firstRow && isEmpty(firstRow.ssrcode)) {
        obj = {
          ...firstRow,
          fullName,
          ssrcode: ssr.ssrcode,
          ssrid: ssr.ssrid,
          ssrname: ssr.ssrname,
          ssr_chargeableamount: ssr.chargeableamount,
          origin:
            sector && sector.split('-')[0]
              ? sector.split('-')[0].trim()
              : firstRow.origin,
          destination:
            sector && sector.split('-')[1]
              ? sector.split('-')[1].trim()
              : firstRow.destination,
        };
      } else {
        obj = {
          ...firstRow,
          fullName,
          ssrcode: ssr.ssrcode,
          ssrid: ssr.ssrid,
          ssrname: ssr.ssrname,
          ssr_chargeableamount: ssr.chargeableamount,
        };
      }
      userSelectedSsrRowsTemp[sector].specialSsrRows[activeSsrIndex] = {
        ...obj,
      };
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      updatePrice(userSelectedSsrRowsTemp);
    }
  };
  const handleRemoveSpecialSsr = (ssr, index) => {
    const { origin, destination } = ssr;
    const sector = `${origin} - ${destination}`;
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    if (
      userSelectedSsrRowsTemp[sector] &&
      userSelectedSsrRowsTemp[sector].specialSsrRows
    ) {
      const userSsrRows = userSelectedSsrRowsTemp[sector].specialSsrRows;
      const byName = getByName(userSsrRows);
      const keys = Object.keys(byName);
      const fullName = keys[index];
      const firstRow = byName[fullName][0];
      if (firstRow && firstRow.hasSsr) {
        return;
      }
      const baggageIndex = userSsrRows.findIndex(
        (b) =>
          b.hasSsr !== true &&
          b.fullName === fullName &&
          b.ssrcode === ssr.ssrcode,
      );
      userSsrRows[baggageIndex] = {
        ...userSsrRows[baggageIndex],
        ssrcode: '',
        ssrid: '',
        ssrname: '',
        ssr_chargeableamount: '',
      };
      userSelectedSsrRowsTemp[sector].specialSsrRows = userSsrRows;
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      updatePrice(userSelectedSsrRowsTemp);
    }
  };

  const getSelectedSpecailSsr = (userSpecialSsrRows, index, sector) => {
    const filtered = userSpecialSsrRows.filter(
      (row) => row.ssrname !== '' && row.ssr_chargeableamount !== '',
    );
    return filtered.length === 0 ? (
      'Select Special SSR'
    ) : (
      <ul className="selected-meals">
        {filtered.map((ssr, bmi) => (
          <li key={bmi}>
            <span>
              {ssr.ssrname} • {formatCurrency(ssr.ssr_chargeableamount)}
            </span>
            {ssr.hasSsr !== true && (
              <AppIconButton
                onClick={() => handleRemoveSpecialSsr(ssr, index, sector)}
                variant="secondary"
              >
                <MdClose />
              </AppIconButton>
            )}
          </li>
        ))}
      </ul>
    );
  };

  const handleSeatSelection = (seat, sector) => {
    if (seat.seatstatus === 'Open') {
      const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
      if (userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].hasSsr) {
        setAlert({
          title: 'Seat Selection',
          description: `You have already booked ${userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode} seat. You can't book another seat.`,
          variant: 'warn',
        });
      } else if (
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode !==
          seat.seatdesignator &&
        userSelectedSsrRowsTemp[sector].seatRows.filter(
          (x) => x.ssrcode === seat.seatdesignator,
        ).length > 0
      ) {
        setAlert({
          title: 'Seat Selection',
          description:
            'This seat has been reserved for other passenger. Please choose a different seat.',
          variant: 'warn',
        });
      } else if (
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode ===
        seat.seatdesignator
      ) {
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode = '';
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrid = '';
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrname = '';
        userSelectedSsrRowsTemp[sector].seatRows[
          activeSeatIndex
        ].ssr_chargeableamount = '';
      } else {
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode =
          seat.seatdesignator;
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrid =
          seat.seatgroup;
        userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrname =
          seat.seatgroup;
        userSelectedSsrRowsTemp[sector].seatRows[
          activeSeatIndex
        ].ssr_chargeableamount = seat.seatprice;
      }
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      updatePrice(userSelectedSsrRowsTemp);
    }
  };

  const handleRemoveSeat = (seat, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode = '';
    userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrid = '';
    userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrname = '';
    userSelectedSsrRowsTemp[sector].seatRows[
      activeSeatIndex
    ].ssr_chargeableamount = '';

    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
    updatePrice(userSelectedSsrRowsTemp);
  };

  const handleConfirmPopupClose = (isConfirm) => {
    setShowConfirmPopup(false);
    if (isConfirm) {
      handleMakePayment();
    }
  };

  return (
    <>
      {isLoading && <AppLoading isLoading={isLoading} />}
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => {
            setAlert(undefined);
          }}
        />
      )}
      <div className="flight-booking-page app-container p-3">
        <div className="flight-booking-page_header">
          {searchRequest && (
            <section className="p-3 mb-5 ">
              <h3 className="change-booking-header mb-4">
                Change booking for transaction: {state.airlinePNR}
              </h3>
              <div className="reschedule-info search-info d-flex justify-content-between">
                <div className="search-info--item">
                  <span className="search-info--item_heading">Journey</span>
                  <span className="search-info--item_value text-capitalize">
                    {state.journeyType}
                  </span>
                </div>
                <div className="search-info--item">
                  <span className="search-info--item_heading">Destination</span>
                  <span className="search-info--item_value primary-color">
                    {`${searchRequest.OriginFullName} - ${searchRequest.DestinationFullName}`}
                  </span>
                </div>
                <div className="search-info--item">
                  <span className="search-info--item_heading">Date</span>
                  <span className="search-info--item_value">
                    {formatDate(
                      getNewDate(searchRequest.JourneyDate),
                      DATE_MONTH_DAY_FORMAT,
                    )}
                  </span>
                </div>
                {!isEmpty(selectedReturnFlight) && (
                  <div className="search-info--item">
                    <span className="search-info--item_heading">
                      Return Date
                    </span>
                    <span className="search-info--item_value">
                      {formatDate(
                        getNewDate(selectedReturnFlight.flightlegs[0].depdate),
                        DATE_MONTH_DAY_FORMAT,
                      )}
                    </span>
                  </div>
                )}
                <div className="search-info--item">
                  <span className="search-info--item_heading">Passengers</span>
                  <span className="search-info--item_value">
                    {searchRequest.passengers.length} Passengers
                  </span>
                </div>
              </div>
            </section>
          )}
          {selectedOnwardFlight && (
            <>
              {selectedReturnFlight && <div>Onward Flight</div>}
              <SelectedFlightDetails selectedFlight={selectedOnwardFlight} />
            </>
          )}
          {selectedReturnFlight && (
            <>
              <div>Return Flight</div>
              <SelectedFlightDetails selectedFlight={selectedReturnFlight} />
            </>
          )}
          <div className="my-2 d-flex flex-column gap-2">
            <h6>Passenger Details</h6>
            {searchRequest.passengers.map((pax) => (
              <span key={pax.paxid} className="fs-14 fw-500">
                {pax.fullname}
              </span>
            ))}
          </div>
          <div className="seperator" />
          <section className="add-ons-section">
            <div className="p-3 add-ons-section__header">
              <h4 className="add-ons-section__title mb-0">Pick your add-ons</h4>
            </div>
            <div className="d-flex flex-wrap">
              <div className="m-2">
                <AppIconButton
                  onClick={() => handleAddAddOn(ADDONS.SEATS)}
                  variant="primary"
                  className="p-0"
                >
                  <img src="/images/others/Seat.png" alt="" />
                </AppIconButton>
              </div>

              <div className="m-2">
                <AppIconButton
                  onClick={() => handleAddAddOn(ADDONS.BAGGAGE)}
                  variant="primary"
                  className="p-0"
                >
                  <img src="/images/others/Baggage1.png" alt="" />
                </AppIconButton>
              </div>
              <div className="m-2">
                <AppIconButton
                  onClick={() => handleAddAddOn(ADDONS.MEALS)}
                  variant="primary"
                  className="p-0"
                >
                  <img src="/images/others/Meal.png" alt="" />
                </AppIconButton>
              </div>
              <div className="m-2">
                <AppIconButton
                  onClick={() => handleAddAddOn(ADDONS.SPECIAL_SSR)}
                  variant="primary"
                  className="p-0 special-ssr-btn"
                >
                  <div>
                    <MdWheelchairPickup />
                    <span>Special SSR</span>
                  </div>
                </AppIconButton>
              </div>
            </div>
          </section>
          <div className="seperator" />

          {fareSummaryRef.current && (
            <section className="reschedule-price-details p-3">
              <h3 className="reschedule-price-details__title mb-4">
                Fare summary
              </h3>
              <div className="d-flex mb-2">
                <span className="secondary-text reschedule-price-details__label me-5">
                  Old Fare
                </span>
                <span className="reschedule-price-details__fare">
                  {formatCurrency(fareSummaryRef.current.oldFare)}
                </span>
              </div>
              <div className="d-flex mb-2">
                <span className="secondary-text reschedule-price-details__label me-5">
                  New Fare
                </span>
                <span className="reschedule-price-details__fare">
                  {formatCurrency(fareSummaryRef.current.newFare)}
                </span>
              </div>
              <div className="d-flex mb-2">
                <span className="secondary-text reschedule-price-details__label me-5">
                  Reschedule Charges
                </span>
                <span className="reschedule-price-details__fare">
                  {formatCurrency(fareSummaryRef.current.reschedulePanalties)}
                </span>
              </div>
              <div className="d-flex mb-2">
                <span className="secondary-text reschedule-price-details__label me-5">
                  Amount to be paid
                </span>
                <span className="reschedule-price-details__fare">
                  {formatCurrency(fareSummaryRef.current.amountTobePaid)}
                </span>
              </div>
              <div className="separator" />
              {showPrice && (
                <section className="pb-3 d-flex flex-column">
                  {priceSummary.map(
                    (price, priceIndex) =>
                      price.show && (
                        <div key={priceIndex} className="d-flex mt-2">
                          <span className="reschedule-price-details__label secondary-text me-5">
                            {price.label}
                          </span>
                          <span className="fw-500 reschedule-price-details__fare">
                            {formatCurrency(price.value)}
                          </span>
                        </div>
                      ),
                  )}
                </section>
              )}
              <hr style={{ width: '315px' }} />
              <div className="d-flex">
                <span className="secondary-text reschedule-price-details__label me-5">
                  Total Payable
                </span>
                <span className="reschedule-price-details__fare">
                  {formatCurrency(
                    fareSummaryRef.current.amountTobePaid +
                      totalFareRef.current,
                  )}
                </span>
              </div>
            </section>
          )}
          <div className="d-flex justify-content-between">
            <AppTextInput
              name="remarks"
              placeholderText=""
              label="Remarks"
              onChange={(e) => setRemarks(e.target.value)}
            />
            <AppButton
              btnText="Book"
              onClick={() => setShowConfirmPopup(true)}
            />
          </div>

          {showSeatMap &&
            Object.keys(flightLegsWithSeatsRef.current).length > 0 && (
              <SeatSelectionComponent
                showSeatMap={showSeatMap}
                setShowSeatMap={setShowSeatMap}
                flightLegsWithSeatsRef={flightLegsWithSeatsRef.current}
                userSelectedSsrRows={userSelectedSsrRows}
                activeSeatIndex={activeSeatIndex}
                seatSelectionSector={seatSelectionSector}
                setSeatSelectionSector={setSeatSelectionSector}
                setActiveSeatIndex={setActiveSeatIndex}
                isNormalBooking={false}
                handleRemoveSeat={handleRemoveSeat}
                handleSeatSelection={handleSeatSelection}
              />
            )}
          {showMeals && (
            <MealSelectionComponent
              showMeals={showMeals}
              setShowMeals={setShowMeals}
              flightLegsWithMealRef={flightLegsWithMealRef.current}
              mealSelectionSector={mealSelectionSector}
              setMealSelectionSector={setMealSelectionSector}
              userSelectedSsrRows={userSelectedSsrRows}
              activeMealIndex={activeMealIndex}
              setActiveMealIndex={setActiveMealIndex}
              getSelectedMeals={getSelectedMeals}
              handleRemoveMeal={handleRemoveMeal}
              handleAddMeal={handleAddMeal}
              isNormalBooking={false}
            />
          )}
          {showBaggage && (
            <BaggageSelectionComponent
              showBaggage={showBaggage}
              setShowBaggage={setShowBaggage}
              flightLegsWithBaggageRef={flightLegsWithBaggageRef.current}
              baggageSelectionSector={baggageSelectionSector}
              setBaggageSelectionSector={setBaggageSelectionSector}
              userSelectedSsrRows={userSelectedSsrRows}
              activeBagIndex={activeBagIndex}
              setActiveBagIndex={setActiveBagIndex}
              getSelectedBaggage={getSelectedBaggage}
              handleRemoveBaggage={handleRemoveBaggage}
              handleAddBaggage={handleAddBaggage}
              isNormalBooking={false}
            />
          )}
          {showSpecialSsr && (
            <SpecialSsrSelectionComponent
              showSpecialSsr={showSpecialSsr}
              setShowSpecialSsr={setShowSpecialSsr}
              flightLegsWithSpecialSsr={flightLegsWithSpecialSsrRef.current}
              handleAddSpecialSsr={handleAddSpecialSsr}
              specialSsrSelectionSector={specialSsrSelectionSector}
              setSpecialSsrSelectionSector={setSpecialSsrSelectionSector}
              userSelectedSsrRows={userSelectedSsrRows}
              activeSsrIndex={activeSsrIndex}
              setActiveSsrIndex={setActiveSsrIndex}
              getSelectedSpecailSsr={getSelectedSpecailSsr}
              handleRemoveSpecialSsr={handleRemoveSpecialSsr}
              isNormalBooking={false}
            />
          )}
          {showConfirmPopup && (
            <AppModal
              modalTitle="Check Details and Reconfirm"
              onModalClose={handleConfirmPopupClose}
              okText="Confirm"
              cancelText="Cancel"
              showFooter
            >
              {fareSummaryRef.current && (
                <section className="reschedule-price-details p-3">
                  <div className="d-flex mb-2">
                    <span className="secondary-text reschedule-price-details__label me-5">
                      Old Fare
                    </span>
                    <span className="reschedule-price-details__fare">
                      {formatCurrency(fareSummaryRef.current.oldFare)}
                    </span>
                  </div>
                  <div className="d-flex mb-2">
                    <span className="secondary-text reschedule-price-details__label me-5">
                      New Fare
                    </span>
                    <span className="reschedule-price-details__fare">
                      {formatCurrency(fareSummaryRef.current.newFare)}
                    </span>
                  </div>
                  <div className="d-flex mb-2">
                    <span className="secondary-text reschedule-price-details__label me-5">
                      Reschedule Charges
                    </span>
                    <span className="reschedule-price-details__fare">
                      {formatCurrency(
                        fareSummaryRef.current.reschedulePanalties,
                      )}
                    </span>
                  </div>
                  <div className="d-flex mb-2">
                    <span className="secondary-text reschedule-price-details__label me-5">
                      Amount to be paid
                    </span>
                    <span className="reschedule-price-details__fare">
                      {formatCurrency(fareSummaryRef.current.amountTobePaid)}
                    </span>
                  </div>
                  {showPrice && (
                    <section className="pb-3 d-flex flex-column">
                      {priceSummary.map(
                        (price, priceIndex) =>
                          price.show && (
                            <div key={priceIndex} className="d-flex mt-2">
                              <span className="reschedule-price-details__label secondary-text me-5">
                                {price.label}
                              </span>
                              <span className="fw-500 reschedule-price-details__fare">
                                {formatCurrency(price.value)}
                              </span>
                            </div>
                          ),
                      )}
                    </section>
                  )}
                  <hr style={{ width: '315px' }} />
                  <div className="d-flex">
                    <span className="secondary-text reschedule-price-details__label me-5">
                      Total Payable
                    </span>
                    <span className="reschedule-price-details__fare">
                      {formatCurrency(
                        fareSummaryRef.current.amountTobePaid +
                          totalFareRef.current,
                      )}
                    </span>
                  </div>
                </section>
              )}
            </AppModal>
          )}
        </div>
      </div>
    </>
  );
}

export default ResheduleBookingPage;
